{
  "certificateCategory": {
    "OTHER_INITIATIVES": "Other initiatives",
    "SCOPE": "Scope",
    "TRANSACTION": "Transaction",
    "UNKNOWN": "Unknown"
  },
  "certificateRequestActions": {
    "accept": "Yes",
    "changeToRejected": "Reject",
    "question": "Does the provided document match the selection ?",
    "reject": "No"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Validated",
    "CANCELED": "Canceled",
    "OPENED": "Open",
    "REJECTED": "Rejected",
    "SUBMITTED": "Pending review"
  },
  "certificateStatus": {
    "NOT_UPLOADED": "Not uploaded",
    "PENDING": "Pending",
    "PROCESSED": "Transcripted",
    "REJECTED": ""
  },
  "filters": {
    "search": {
      "placeholder": "Search"
    },
    "title": "Filters"
  },
  "lists": {
    "columns": {
      "businessPartner": {
        "header": "Sent by",
        "tooltip": "Sender of the document."
      },
      "category": {
        "header": "Category",
        "OTHER_INITIATIVES": "Other initiatives",
        "SCOPE": "Scope",
        "tooltip": "Scope, Transaction, Other initiative, Other.",
        "TRANSACTION": "Transaction",
        "UNKNOWN": "Unknown"
      },
      "certificateRequests": {
        "canceled_one": "{{count}} certificate request canceled",
        "canceled_many": "{{count}} certificates requests canceled",
        "canceled_other": "{{count}} certificates requests canceled",
        "header": "Requests",
        "rejected_one": "{{count}} certificate request rejected",
        "rejected_many": "{{count}} certificates requests rejected",
        "rejected_other": "{{count}} certificates requests rejected",
        "submitted_one": "{{count}} certificates requests pending approval",
        "submitted_many": "{{count}} certificates requests pending approval",
        "submitted_other": "{{count}} certificates requests pending approval",
        "tooltip": "Certificate requests associated with this document.",
        "validated_one": "{{count}} certificate requests validated",
        "validated_many": "{{count}} certificates requests validated",
        "validated_other": "{{count}} certificates requests validated"
      },
      "createdAt": {
        "header": "Sent on",
        "tooltip": "Date of sending of the document."
      },
      "expiryDate": {
        "header": "Valid to",
        "tooltip": "Date of expiry of the document."
      },
      "issueDate": {
        "header": "Valid from",
        "tooltip": "Date of issue of the document."
      },
      "name": {
        "header": "Name",
        "tooltip": "Name or title of the document."
      },
      "productionSite": {
        "deleted": "Production site deleted",
        "header": "Apply to (site)",
        "tooltip": "Production site associated with the document."
      },
      "purchaseOrders": {
        "component": {
          "header": "Sent for (Component PO)",
          "tooltip": "Sent for (Component PO): List of component purchase order numbers for which this document was submitted."
        },
        "material": {
          "header": "Sent for (Material PO)",
          "tooltip": "Sent for (Material PO): List of material purchase order numbers for which this document was submitted."
        },
        "product": {
          "header": "Sent for (Product PO)",
          "tooltip": "Sent for (Product PO): List of finished product purchase order numbers for which this document was submitted."
        }
      },
      "reference": {
        "header": "Reference",
        "tooltip": "Identifier code of the document."
      },
      "score": {
        "header": "Rating",
        "tooltip": "Grade or level associated with the document. This reflects the compliance or performance level achieved according to the document's standards."
      },
      "status": {
        "header": "Transcription",
        "tooltip": "Document status. A document must be transcribed to be properly used."
      },
      "type": {
        "header": "Sub-category",
        "tooltip": "Document type."
      }
    },
    "placeholders": {
      "businessPartner": "Sent by",
      "category": "Category",
      "certificateRequestStatus": "Requests",
      "certificateStatus": "Transcription",
      "certificateType": "Sub-category",
      "componentPOs": "Sent for Component POs",
      "createdAt": "Sent on",
      "materialPOs": "Sent for Material POs",
      "productionSite": "Scope (site)",
      "productPOs": "Sent for Product POs",
      "score": "Rating",
      "search": "Search",
      "validFrom": "Valid from",
      "validTo": "Valid to"
    },
    "tabs": {
      "all": "All",
      "scope": "Certificates & Audits",
      "transaction": "Transaction Proofs"
    },
    "title": "Documents"
  },
  "modal": {
    "associatedRequests": {
      "card": {
        "description": {
          "common": "A <type>{{type}}</type> valid on <maxIssueDate>{{maxIssueDate}}</maxIssueDate> for the site <productionSiteName>{{productionSiteName}}</productionSiteName> owned by <productionSiteOrganizationName>{{productionSiteOrganizationName}}</productionSiteOrganizationName> was requested for the operation <activityName>{{activityName}}</activityName>.",
          "component": "Component: <componentName>{{componentName}}</componentName>",
          "material": "Material: <materialName>{{materialName}}</materialName>",
          "product": "Reference : <productBrandReference>{{productBrandReference}}</productBrandReference> <productColor>({{productColor}})</productColor>",
          "purchaseOrder": "PO: <purchaseOrder>{{purchaseOrder}}</purchaseOrder>"
        },
        "header": "On {{createdAt}}"
      },
      "description": "This document has been submitted by {{sender}} as a response to the following requests:",
      "title": "Information & Associated requests"
    },
    "error": "An error occurred while updating the certificate.",
    "form": {
      "description": {
        "bounded": "This  <b>{{type}}</b>  is valid from  <b>{{issueDate}}</b>  to  <b>{{expiryDate}}</b>  for the site  <b>{{productionSiteName}}</b>  declared by  <b>{{productionSiteOrganizationName}}</b><activityName> for operation <b>{{activityName}}</b></activityName>.",
        "open": "This  <b>{{type}}</b>  is valid on or from the  <b>{{issueDate}}</b>  for the site  <b>{{productionSiteName}}</b>  declared by  <b>{{productionSiteOrganizationName}}</b><activityName>  for operation  <b>{{activityName}}</b></activityName>."
      },
      "summary": "Summary"
    },
    "labels": {
      "buyerOfCertifiedProducts": "Buyer of certified products",
      "certificationBody": "Certification body",
      "certifiedOrganizationAddress": "Certified company address",
      "certifiedOrganizationLicenseNumber": "Company license number",
      "certifiedOrganizationName": "Certified company name",
      "certifiedWeight": "Certified weight",
      "expiryDate": "Expiry date",
      "issueDate": "Issue date",
      "linkedScopeCertificateNumber": "Scope certificate number",
      "manualCheck": "Check the document reference validity on the Okeo-Tex search engine.",
      "name": "Name",
      "processingSteps": "Processing steps",
      "productCategories": "Product categories",
      "productDetails": "Product details",
      "reference": "Reference",
      "rejectionMessage": "Message to supplier",
      "score": "Rating",
      "scoreOptions": {
        "bepi": {
          "advanced": "AMFORI BEPI - Advanced",
          "beginner": "AMFORI BEPI - Beginner",
          "insufficient": "AMFORI BEPI - Insufficient",
          "leader": "AMFORI BEPI - Leader",
          "other": "AMFORI BEPI - Other",
          "progressing": "AMFORI BEPI - Progressing"
        },
        "bsci": {
          "a": "AMFORI BSCI - A",
          "b": "AMFORI BSCI - B",
          "c": "AMFORI BSCI - C",
          "d": "AMFORI BSCI - D",
          "e": "AMFORI BSCI - E",
          "other": "AMFORI BSCI - Other"
        },
        "gots": {
          "certified": "GOTS - Certified",
          "inConversion": "GOTS - In conversion",
          "other": "GOTS - Other",
          "suspended": "GOTS - Suspended",
          "withdrawn": "GOTS - Withdrawn"
        },
        "grs": {
          "certified": "GRS - Certified",
          "inConversion": "GRS - In conversion",
          "other": "GRS - Other",
          "suspended": "GRS - Suspended",
          "withdrawn": "GRS - Withdrawn"
        },
        "higgFem": {
          "beginner": "Higg FEM - Beginner",
          "developing": "Higg FEM - Developing",
          "established": "Higg FEM - Established",
          "leading": "Higg FEM - Leading",
          "other": "Higg FEM - Other"
        },
        "ics": {
          "a": "ICS - A",
          "b": "ICS - B",
          "c": "ICS - C",
          "d": "ICS - D",
          "e": "ICS - E",
          "other": "ICS - Other"
        },
        "iso14001": {
          "certified": "ISO 14001 - Certified",
          "notCertified": "ISO 14001 - Not certified",
          "other": "ISO 14001 - Other",
          "suspended": "ISO 14001 - Suspended",
          "withdrawn": "ISO 14001 - Withdrawn"
        },
        "iso45001": {
          "certified": "ISO 45001 - Certified",
          "notCertified": "ISO 45001 - Not certified",
          "other": "ISO 45001 - Other",
          "suspended": "ISO 45001 - Suspended",
          "withdrawn": "ISO 45001 - Withdrawn"
        },
        "lwg": {
          "audited": "Leather Working Group - Audited (Unrated)",
          "bronze": "Leather Working Group - Bronze",
          "certified": "Leather Working Group - Certified (approved member)",
          "gold": "Leather Working Group - Gold",
          "other": "Leather Working Group - Other",
          "platinum": "Leather Working Group - Platinum",
          "silver": "Leather Working Group - Silver"
        },
        "notApplicable": "Not applicable",
        "oekotex": {
          "ecoPassport": "OEKO-TEX - Eco Passport",
          "leatherStandard": "OEKO-TEX - Leather Standard",
          "madeInGreen": "OEKO-TEX Made in Green",
          "other": "OEKO-TEX - Other",
          "standard100": "OEKO-TEX Standard 100",
          "stepLevel1": "OEKO-TEX Step Level 1",
          "stepLevel2": "OEKO-TEX Step Level 2",
          "stepLevel3": "OEKO-TEX Step Level 3"
        },
        "other": "Other",
        "rcs": {
          "certified": "RCS - Certified",
          "inConversion": "RCS - In conversion",
          "other": "RCS - Other",
          "suspended": "RCS - Suspended",
          "withdrawn": "RCS - Withdrawn"
        },
        "sa8000": {
          "compliant": "SA8000 - Fully Compliant",
          "nonCompliant": "SA8000 - Non-compliant",
          "other": "SA8000 - Other",
          "partlyMajor": "SA8000 - Partly compliant (major issue)",
          "partlyMinor": "SA8000 - Partly compliant (minor issue)"
        },
        "smeta": {
          "criticalNonCompliance": "SMETA - Critical non-compliance",
          "fourPillar": "SMETA - 4-Pillar Audit",
          "majorNonCompliance": "SMETA - Major non-compliance",
          "minorNonCompliance": "SMETA - Minor non-compliance",
          "noNonCompliance": "SMETA - No non-compliance",
          "other": "SMETA - Other",
          "twoPillar": "SMETA - 2-Pillar Audit"
        },
        "wrap": {
          "bronze": "WRAP - Bronze",
          "certified": "WRAP - Certified",
          "gold": "WRAP - Gold",
          "other": "WRAP - Other",
          "platinum": "WRAP - Platinum",
          "silver": "WRAP - Silver"
        }
      },
      "scoreTooltip": "Grade or level associated with the provided certificate. This reflects the compliance or performance level achieved according to the certificate's standards.",
      "status": "Status",
      "type": "Type"
    },
    "placeholders": {
      "buyerOfCertifiedProducts": "Enter the buyer of certified products",
      "certificationBody": "Enter the certification body",
      "certifiedOrganizationAddress": "Certified company address",
      "certifiedOrganizationLicenseNumber": "Enter the company license number",
      "certifiedOrganizationName": "Enter the certified company name",
      "certifiedWeight": "Enter the certified weight",
      "expiryDate": "Select an expiry date",
      "issueDate": "Select an issue date",
      "linkedScopeCertificateNumber": "Enter the linked scope certificate number",
      "name": "Enter the name",
      "processingSteps": "Enter the processing steps",
      "productCategories": "Enter the product categories",
      "productDetails": "Enter the product details",
      "reference": "Enter the reference number",
      "rejectionMessage": "The document is expired, not legible, etc.",
      "score": "Enter the rating",
      "status": "Enter the status",
      "type": "Select a certificate type"
    },
    "rejectModal": {
      "submit": "Reject",
      "subtitle": "Please review the PDF carefully and verify that all required information has been correctly entered in the form. If the document is not legible or is the wrong type, you may reject the certificate.",
      "title": "Reject certificate"
    },
    "rejectToolTips": "Please note: An email will be sent to the supplier with your reason for rejecting the certificate. This will notify them and help ensure that the issue is addressed promptly.",
    "submit": "Save",
    "success": "Certificate updated successfully!",
    "successAccept": "Certificate has been accepted.",
    "successReject": "Certificate has been rejected and an email has been sent to the supplier.",
    "summary": {
      "tab": {
        "title": "Document & Information"
      }
    }
  },
  "sorts": {
    "category": "Category",
    "createdAt": "Sent on",
    "documentStatus": "Transcription",
    "expiryDate": "Valid to",
    "issueDate": "Valid from",
    "name": "Name",
    "productionSite": "Apply to (site)",
    "reference": "Reference",
    "score": "Rating",
    "totalRequests": "Total requests"
  },
  "standard": {
    "badge": {
      "compliant": "Compliant",
      "notCompliant": "Not compliant"
    },
    "drawer": {
      "certificatesNumber": "{{completedCertificates}}/{{totalCertificates}} expected document(s)",
      "complianceRules": "Rules",
      "rules": {
        "certificationBody": {
          "description": {
            "failure": "At least one collected document has a different certifying body than the other documents applied to the same production step.",
            "success": "Documents collected for the same production step were issued by the same certifying body"
          },
          "title": "Certifying bodies"
        },
        "certifiedEntity": {
          "description": {
            "failure": "At least one collected document has a different certified facility than the other documents applied to the same production step.",
            "success": "Documents collected for the same production step apply to the same facility."
          },
          "title": "Certified facilities"
        },
        "productCategories": {
          "description": {
            "failure": "At least one collected document does not cover the same category as the other documents applied to the same production step.",
            "success": "Documents collected for the same production step cover the same categories."
          },
          "title": "Categories"
        },
        "relevantStandard": {
          "description": {
            "failure": "At least one collected document does not relate to the right standard.",
            "success": "Documents collected for the same production step relate to the right standard."
          },
          "title": "Relevant standard"
        },
        "validityPeriod": {
          "description": {
            "failure": "At least one collected document is not valid during the same period as the other documents applied to the same production step.",
            "success": "Documents collected for the same production step are valid during the same time period."
          },
          "title": "Validity periods"
        }
      }
    }
  }
}
